import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from './home/home.component';
import { GuestsComponent } from './guests/guests.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { TermsComponent } from './terms/terms.component';
import { AuthGuard } from './auth.guard';
import { SecureAccessComponent } from './secure-access/secure-access.component';
import { QrCodeComponent } from './qr-code/qr-code.component';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  // rotte protette
  { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
  { path: 'guests', component: GuestsComponent, canActivate: [AuthGuard] },
  { path: 'privacy', component: PrivacyComponent, canActivate: [AuthGuard] },
  { path: 't&c', component: TermsComponent, canActivate: [AuthGuard] },

  // rotta pubblica
  { path: 'qr-code', component: QrCodeComponent },
  { path: 'secure-access', component: SecureAccessComponent }
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
